import { render } from "./ModalChooseApplicants.vue?vue&type=template&id=322c2c60&ts=true"
import script from "./ModalChooseApplicants.vue?vue&type=script&lang=ts"
export * from "./ModalChooseApplicants.vue?vue&type=script&lang=ts"

import "./ModalChooseApplicants.vue?vue&type=style&index=0&id=322c2c60&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__